export default __webpack_public_path__ + "static/media/รหัสและสถานะบัญชี.13adbcff.pdf";